export const langResourceConfig = {
    core: "/Itslearning/ItslCore/strings/strings.resx",
    main: "/Itslearning/Web/strings/strings.resx",
    assignment: "/Itslearning/Extensions/Applications/Assignment/Assignment.Web/LocalizationWeb/Resources/Localization.resx",
    myLibrary: "/Resources/Web/MyLibrary/MyLibraryResources.resx"
};
